<template>
  <div class="container">
    <div class="searchArea">
      <div class="search-side"><img src="@/assets/img/CA_Player_black.png" class="entity_logo floatright align-entity" /></div>
      <div class="search-combo">
        <input type="text" class="search-box" v-model.lazy="searchString" v-debounce="1000" :placeholder="$t('persons.search')" autofocus>
        <font-awesome-icon icon="search" class="icon-overlap"/>
      </div>
      <div class="search-side">
        <div v-if="isLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div>
      </div>
    </div>

    <persons-list :persons="persons" :listType="'Card'"></persons-list>
  </div>
</template>

<script>
import PersonsList from "@/components/players/PersonsList";
import {RestAPI} from "@aws-amplify/api-rest";


const apiName = 'api';
const listPath = '/Person';
const myInit = { // OPTIONAL
  response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
};


export default {
  name: 'PersonsDashboard',
  components: {PersonsList},
  data: function () {
    return {
      lastKey: "",
      loading: false,
      persons: [],
      searchString: "",
    }
  },
  mounted() {
    console.log("Mounted");
  },
  computed: {
    isLoading() {
      return this.loading;
    }
  },
  watch: {
    searchString: function () {
      this.loadPersons();
    }
  },
  methods: {
    loadPersons: function() {
      console.log("set loading to true: " + this.loading);
      let that = this;
      var fullPath = "";
      if (this.searchString != "") {
        this.loading = true;
        console.log(this.searchString);
        fullPath = listPath + "?name=" + encodeURIComponent(this.searchString)
        console.log("person search on: " + fullPath);
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.persons = response;
          }) 
          .catch(error => {
            console.log(error.response);
          })
          .finally(() => {
            // Stop the spinner 
            this.loading = false;
          });
      } else {
        that.persons = [];
        this.loading = false;
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-body {
    display: block;
}

.spincontainer {
  margin-left: 10px;
  padding-top: 12px;
}

@keyframes spinner {
  to { transform: rotate(360deg); }
}
.fa-spinner {
  animation: spinner 3s linear infinite;
}


/* mobile */
@media screen and (max-width: 600px) {
  .container {
    padding: 1vw;
    width: 98vw;
  }

  input {
    width: 95vw;
  }

  header {
    padding: 1vw;
  }
}


/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    padding: 1vw;
    width: 70vw;
  }

  input {
    width: 30vw;
  }

  header {
    padding: 1vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    padding: 1vw;
    width: 50vw;
  }

  input {
    width: 30vw;
  }

  header {
    padding: 1vw;
  }
}


</style>
